import React from 'react';
import type { Step } from 'react-joyride';

export type TourStep = Step & { id: string; description?: string | React.ReactNode };

const welcomeContent = React.createElement(
  'div',
  { style: { textAlign: 'center' } },
  React.createElement(
    'div',
    { style: { fontSize: 18, fontWeight: 700 as React.CSSProperties['fontWeight'], marginBottom: 8 } },
    'Welcome!'
  ),
  React.createElement(
    'div',
    { style: { fontSize: 14, color: 'rgb(var(--gray-700))' } }, // #374151 == --gray-700
    'Go ahead and take a brief tour. It will take less than a minute.'
  )
);

export const defaultWalkthroughSteps: TourStep[] = [
  {
    id: 'welcome',
    target: 'body',
    placement: 'center',
    content: welcomeContent,
    disableBeacon: true,
    hideCloseButton: true,
  },
  {
    id: 'start-project',
    target: '#new-project-btn',
    content: 'Start by creating your first project.',
    placement: 'bottom',
    spotlightPadding: 16,
    disableBeacon: true,
  },
  {
    id: 'create-project',
    target: '#new-project-dialog',
    content: 'Fill out the project details and create the project (you can use a made‑up one to test 😉).',
    placement: 'right',
    spotlightPadding: 0,
    disableBeacon: true,
  },
  {
    id: 'open-project-management',
    target: '#nav-project-management',
    content: 'Open Project Management from the sidebar.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    id: 'open-todos',
    target: '#nav-todos',
    content: "Go to To-Do's to add your first task.",
    placement: 'right',
    disableBeacon: true,
  },
  {
    id: 'goto-todos',
    target: '#new-todo-btn',
    content: 'Now add your first to-do for the project.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    id: 'todo-form',
    target: '#new-todo-dialog',
    content: 'Use this form to describe the task and assign it.',
    placement: 'right',
    spotlightPadding: 12,
    disableBeacon: true,
  },
  {
    id: 'finish',
    target: '#new-todo-btn',
    content: "You're all set! Keep adding tasks to stay organized.",
    placement: 'bottom',
    disableBeacon: true,
  },
];

export type { Step };

export const getDefaultSteps = (): Step[] => defaultWalkthroughSteps;
